import styles from './_HomeAndScenarioButtonContainer.module.scss';
import { scenarioNavItems } from './constants';
import HomeIconBlue from './images/home-icon-blue.svg';
import HomeIconWhite from './images/home-icon-white.svg';
import ScenarioViewIconBlue from './images/scenario-view-icon-blue.svg';
import ScenarioViewIconWhite from './images/scenario-view-icon-white.svg';
import {
    BASE_ROUTE,
    SCENARIO_FOUR_ROUTE,
    SCENARIO_ONE_ROUTE,
    SCENARIO_THREE_ROUTE,
    SCENARIO_TWO_ROUTE
} from 'constants/routes';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const HomeAndScenarioButtonContainer = ({
    navigateTo,
    navMenuItemHovered,
    setNavMenuItemHovered
}) => {
    const { pathname } = useLocation();
    const [homeIsHovered, setHomeIsHovered] = useState(false);
    const [scenarioViewIsHovered, setScenarioViewIsHovered] = useState(false);
    const isScenarioRoute =
        pathname === SCENARIO_ONE_ROUTE ||
        pathname === SCENARIO_TWO_ROUTE ||
        pathname === SCENARIO_THREE_ROUTE ||
        pathname === SCENARIO_FOUR_ROUTE;
    const indexToRouteMapping = {
        0: SCENARIO_ONE_ROUTE,
        1: SCENARIO_TWO_ROUTE,
        2: SCENARIO_THREE_ROUTE,
        3: SCENARIO_FOUR_ROUTE
    };
    const titleToRouteMapping = {
        S1: SCENARIO_ONE_ROUTE,
        S2: SCENARIO_TWO_ROUTE,
        S3: SCENARIO_THREE_ROUTE,
        S4: SCENARIO_FOUR_ROUTE
    };
    const onHomeClick = () => {
        navigateTo(pathname, '/');
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.homeNav} onClick={onHomeClick}>
                <div
                    className={
                        pathname === BASE_ROUTE
                            ? styles.borderedHomeContainer
                            : styles.homeContainer
                    }
                    onMouseOver={() => setHomeIsHovered(true)}
                    onMouseOut={() => setHomeIsHovered(false)}
                >
                    <img
                        className={styles.homeIcon}
                        src={
                            homeIsHovered || pathname === BASE_ROUTE
                                ? HomeIconWhite
                                : HomeIconBlue
                        }
                        alt=""
                    />
                    {(homeIsHovered || pathname === BASE_ROUTE) && (
                        <p className={styles.homeText}>Home</p>
                    )}
                </div>
            </div>
            <div
                className={styles.scenarioNav}
                onMouseOver={() => setScenarioViewIsHovered(true)}
                onMouseOut={() => setScenarioViewIsHovered(false)}
            >
                <div
                    className={
                        isScenarioRoute
                            ? styles.borderedScenarioViewContainer
                            : styles.scenarioViewContainer
                    }
                >
                    {scenarioViewIsHovered && (
                        <div className={styles.navigationMenu}>
                            {scenarioNavItems.map((item, idx) => (
                                <div
                                    className={styles.dropdownTextContainer}
                                    key={`navItem-${idx}`}
                                    onMouseOver={() =>
                                        setNavMenuItemHovered(idx)
                                    }
                                    onMouseOut={() => {
                                        setNavMenuItemHovered(null);
                                        setScenarioViewIsHovered(false);
                                    }}
                                    onClick={() => {
                                        setScenarioViewIsHovered(false);
                                        navigateTo(
                                            pathname,
                                            indexToRouteMapping[idx]
                                        );
                                    }}
                                >
                                    <span
                                        className={
                                            navMenuItemHovered === idx ||
                                            titleToRouteMapping[item.title] ===
                                                pathname
                                                ? styles.hoveredTitle
                                                : styles.title
                                        }
                                    >
                                        {item.title}
                                    </span>
                                    <span
                                        className={
                                            navMenuItemHovered === idx ||
                                            titleToRouteMapping[item.title] ===
                                                pathname
                                                ? styles.hoveredSubtitle
                                                : styles.subTitle
                                        }
                                    >
                                        {item.subTitle}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                    <img
                        src={
                            scenarioViewIsHovered || isScenarioRoute
                                ? ScenarioViewIconWhite
                                : ScenarioViewIconBlue
                        }
                        alt=""
                    />
                    {(scenarioViewIsHovered || isScenarioRoute) && (
                        <span className={styles.scenarioViewText}>
                            Scenario View
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

HomeAndScenarioButtonContainer.propTypes = {
    navigateTo: PropTypes.func,
    navMenuItemHovered: PropTypes.number,
    setNavMenuItemHovered: PropTypes.func
};
export default HomeAndScenarioButtonContainer;
